import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TechSpecsSection } from '../components/TechSpecsSection';
import { ComparisonTableSection } from '../components/ComparisonTableSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ServiceAreaSection } from '../components/ServiceAreaSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { SecondaryServicesSection } from '../components/SecondaryServicesSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
export function HomePage() {
  return <>
      <Hero data-id="element-1259" />
      <ProblemSection data-id="element-1260" />
      <SolutionSection data-id="element-1261" />
      <BenefitsSection data-id="element-1262" />
      <TechSpecsSection data-id="element-1263" />
      <ComparisonTableSection data-id="element-1264" />
      <HowItWorksSection data-id="element-1265" />
      <ServiceAreaSection data-id="element-1266" />
      <WhyChooseUsSection data-id="element-1267" />
      <SecondaryServicesSection data-id="element-1268" />
      <FAQSection data-id="element-1269" />
      <CTASection data-id="element-1270" />
    </>;
}